/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { changeLoading } from '../../store';
import {
  getOrderDetail,
  getVendorCourier,
  packedStatusOrder,
  requestResolveOrder,
  shippedStatusOrder,
  updateStatusOrder,
} from '../../services';
import LoadingComponent from '../../atoms/LoadingComponent';
import {
  formatDate,
  formatMoney,
  getFileExtension,
  formatDateTimeSecond,
} from '../../helper/lib';
import { IsAlert } from '../../atoms/IsAlert';
import FileUpload from '../../organism/FileUpload/FileUpload';
import ArrowLeft from '../../assets/img/custom/caret-left-light.svg';
import AttachmentPreview from '../../organism/AttachmentPreview';
import 'react-vertical-timeline-component/style.min.css';
import './styles/timeline-style.css';

import moment from 'moment';
import 'moment/locale/id';
moment.locale('id');

const OrderDetail = () => {
  const dispatch = useDispatch();

  const [data, setData] = useState();
  const [id, setId] = useState();
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [couriers, setCouriers] = useState([]);
  const [subDistrict, setSubDistrict] = useState('');

  const [trackingNumber, setTrackingNumber] = useState('');
  const [trackingNumberErrorMessage, setTrackingNumberErrorMessage] =
    useState('');
  const [courierData, setCourierData] = useState('');

  const [showUploadInputImage, setShowUploadInputImage] = useState(true);
  const [showUploadInputVideo, setShowUploadInputVideo] = useState(true);
  const [samplePreview, setSamplePreview] = useState([]);

  // Preview Videos
  const [sampleVideos, setSampleVideos] = useState([]);

  const navigate = useNavigate();
  let { slug } = useParams();

  const getIdFromSlug = (slug) => {
    let id = slug.split('-').pop();
    return id;
  };

  const validateString = (string) =>
    string === null || string === undefined || string === '' ? '-' : string;

  const getCourierData = async () => {
    setIsLoadingData(true);
    try {
      const response = await getVendorCourier();

      if (response.meta.total > 0 && response.message === 'Success') {
        setCouriers(response.data.filter((c) => c.is_active));
      }
    } catch (error) {
      throw error;
    } finally {
      setIsLoadingData(false);
    }
  };

  const getOrderDetailData = async () => {
    setIsLoadingData(true);
    try {
      const res = await getOrderDetail(id);
      if (res.meta.total > 0 && res.message === 'Success') {
        setData(res.data);
        setCourierData({
          ...courierData,
          name: res?.data?.courier_name,
          service: res?.data?.courier_service_name,
        });

        setId(id);
        setIsLoadingData(false);

        if (res?.data?.status === 'Confirmed') {
          getCourierData();
        }
      }
    } catch (error) {
      setIsLoadingData(false);
      navigate('/orders');
    }
  };

  const handleUpload = async (files) => {
    if (samplePreview.length + files.length > 1) {
      IsAlert.fire({
        title: 'Error',
        text: 'Maximum Upload 1 Files',
        icon: 'error',
      });

      return;
    }
    files.forEach(async (file) => {
      const fileExtension = await getFileExtension(file.name);

      const fsize = Math.round((file.size / 1000000) * 100) / 100;
      if (!['jpeg', 'jpg', 'png'].includes(fileExtension.toLowerCase())) {
        // Alert
        IsAlert.fire({
          title: 'Error',
          text: 'Please upload file with the following extension only: jpeg, jpg, png',
          icon: 'error',
        });

        return;
      }

      if (fsize > 40.0) {
        IsAlert.fire({
          title: 'Error',
          text: 'Please upload image with a size of 40 MB or less per file',
          icon: 'error',
        });
        return;
      }

      const previewImage = URL.createObjectURL(file);

      setSamplePreview((prev) => [
        ...prev,
        {
          name: file.name,
          size: fsize,
          preview: previewImage,
          file: file,
          extension: fileExtension,
        },
      ]);

      return;
    });
  };

  const clearImageSelected = (index) => {
    const filtered = samplePreview.filter((_, i) => {
      return i !== index;
    });
    setSamplePreview(filtered);
  };

  const handleRejectOrder = async () => {
    IsAlert.fire({
      title: 'Reject',
      text: 'Are you sure want to reject this order?',
      icon: 'warning',
      showCancelButton: true,
      focusConfirm: true,
      confirmButtonText: 'Reject',
    }).then(async function (isConfirm) {
      if (isConfirm.isConfirmed) {
        try {
          const payload = {
            id: id,
            status: 'reject',
          };
          const res = await updateStatusOrder(payload);
          if (res.meta.total > 0 && res.message === 'Success') {
            navigate('/orders');
          }
        } catch (error) {
          throw error;
        }
      }
    });
  };

  const handleConfirmOrder = async () => {
    IsAlert.fire({
      title: 'Accept',
      text: 'Are you sure want to accept this order?',
      icon: 'warning',
      showCancelButton: true,
      focusConfirm: true,
      confirmButtonText: 'Accept',
    }).then(async function (isConfirm) {
      if (isConfirm.isConfirmed) {
        try {
          const payload = {
            id: id,
            status: 'confirmed',
          };
          const res = await updateStatusOrder(payload);
          if (res.meta.total > 0 && res.message === 'Success') {
            navigate('/orders');
          }
        } catch (error) {
          throw error;
        }
      }
    });
  };

  const handleProcessOrder = async () => {
    IsAlert.fire({
      title: 'Process',
      text: 'Are you sure want to process this order?',
      icon: 'warning',
      showCancelButton: true,
      focusConfirm: true,
      confirmButtonText: 'Process',
    }).then(async function (isConfirm) {
      if (isConfirm.isConfirmed) {
        setIsLoadingData(true);
        let itemsData = [];
        let totalPrice = 0;
        let totalLength = 0;
        let totalWidth = 0;
        let totalWeight = 0;
        let totalHeight = 0;

        data?.items?.forEach((item, index) => {
          itemsData.push({
            name: item?.name,
            price: parseInt(item?.price),
            qty: parseInt(item?.quantity),
          });

          //
          totalPrice += parseInt(item?.price) * parseInt(item?.quantity);
          totalLength += parseInt(item?.lenght) * parseInt(item?.quantity);
          totalWidth += parseInt(item?.width) * parseInt(item?.quantity);
          totalWeight += parseInt(item?.weight) * parseInt(item?.quantity);
          totalHeight += parseInt(item?.height) * parseInt(item?.quantity);

          return;
        });

        let detailsShipper = {
          consignee: {
            name: data?.shipping_address?.recipient,
            phone_number: data?.shipping_address?.phone,
          },
          consigner: {
            name: data?.seller_name,
            phone_number: data?.seller_phone,
          },
          courier: {
            cod: false,
            rate_id: parseInt(data?.courier_service_code),
            use_insurance: true,
          },
          coverage: 'domestic',
          destination: {
            address:
              data?.shipping_address?.address +
              data?.shipping_address?.address2,
            area_id: parseInt(data?.shipping_address?.subdistrict_id),
            lat: '',
            lng: '',
          },
          external_id: data?.order_number,
          origin: {
            address: data?.seller_address,
            area_id: parseInt(data?.subdistrict_id),
            lat: '',
            lng: '',
          },
          package: {
            price: totalPrice,
            length: totalLength,
            width: totalWidth,
            weight: totalWeight,
            package_type: 2,
            items: itemsData,
            height: totalHeight,
          },
          payment_type: 'postpay',
        };

        const payload = { id: id, shipper_order_domestic: detailsShipper };

        try {
          const res = await packedStatusOrder(payload);
          if (res.meta.total > 0 && res.message === 'Success') {
            getOrderDetailData();
            IsAlert.fire({
              title: 'Success',
              text: 'Process order success.',
              icon: 'success',
              showCancelButton: false,
              focusConfirm: true,
              confirmButtonText: 'Confirm',
            });
            return;
          }

          IsAlert.fire({
            title: 'Error',
            text: res.message,
            icon: 'error',
            showCancelButton: false,
            focusConfirm: true,
            confirmButtonText: 'Confirm',
          });
        } catch (error) {
          IsAlert.fire({
            title: 'Error',
            text: error?.response?.data?.message ?? 'Something when wrong.',
            icon: 'error',
            showCancelButton: false,
            focusConfirm: true,
            confirmButtonText: 'Confirm',
          });
        } finally {
          setIsLoadingData(false);
        }
      }
    });
  };

  const handleShippingOrder = async () => {
    IsAlert.fire({
      title: 'Shipping',
      text: 'Are you sure want to ship this order?',
      icon: 'warning',
      showCancelButton: true,
      focusConfirm: true,
      confirmButtonText: 'Confirm',
      reverseButtons: true,
    }).then(async function (isConfirm) {
      if (isConfirm.isConfirmed) {
        dispatch(changeLoading(true));

        const formData = new FormData();
        formData.append('id', parseInt(id));
        formData.append('tracking_number', trackingNumber);

        if (samplePreview.length > 0) {
          samplePreview.forEach((image) => {
            formData.append('images', image.file);
          });
        } else {
          formData.append('images', '');
        }

        if (sampleVideos.length > 0) {
          sampleVideos.forEach((video) => {
            formData.append('video', video.file);
          });
        } else {
          formData.append('video', '');
        }

        try {
          const res = await shippedStatusOrder(formData);

          if (res.meta.total > 0 && res.message === 'Success') {
            getOrderDetailData();
            setSamplePreview([]);
            setSampleVideos([]);

            IsAlert.fire({
              title: 'Success',
              text: 'Shipping order success.',
              icon: 'success',
              showCancelButton: false,
              focusConfirm: true,
              confirmButtonText: 'Confirm',
            });
          }
        } catch (error) {
          IsAlert.fire({
            title: 'Error',
            text: error?.response?.data?.message ?? 'Something when wrong.',
            icon: 'error',
            showCancelButton: false,
            focusConfirm: true,
            confirmButtonText: 'Confirm',
          });
        } finally {
          dispatch(changeLoading(false));
        }
      }
    });
  };

  const handleUploadVideo = async (files) => {
    if (sampleVideos.length + files.length > 1) {
      IsAlert.fire({
        title: 'Error',
        text: 'Maximum Upload 1 Files',
        icon: 'error',
      });

      return;
    }
    files.forEach(async (file) => {
      const fileExtension = await getFileExtension(file.name);
      const fsize = Math.round((file.size / 1000000) * 100) / 100;
      if (!['mov', 'mp4', 'avi'].includes(fileExtension.toLowerCase())) {
        // Alert
        IsAlert.fire({
          title: 'Error',
          text: 'Please upload file with the following extension only: mov, mp4, avi',
          icon: 'error',
        });

        return;
      }

      if (fsize > 40.0) {
        IsAlert.fire({
          title: 'Error',
          text: 'Please upload video with a size of 40 MB or less per file',
          icon: 'error',
        });
        return;
      }

      const previewVideo = URL.createObjectURL(file);

      setSampleVideos((prev) => [
        ...prev,
        {
          name: file.name,
          size: fsize,
          preview: previewVideo,
          file: file,
          extension: fileExtension,
        },
      ]);

      return;
    });
  };

  const clearVideoSelected = (index) => {
    const filtered = sampleVideos.filter((_, i) => {
      return i !== index;
    });
    setSampleVideos(filtered);
  };

  const handleRequestResolve = async () => {
    IsAlert.fire({
      title: 'Request Resolve',
      text: 'Are you sure want to request resolve?',
      icon: 'warning',
      showCancelButton: true,
      focusConfirm: true,
      confirmButtonText: 'Request',
    }).then(async function (isConfirm) {
      if (isConfirm.isConfirmed) {
        dispatch(changeLoading(true));

        try {
          const payload = {
            id: parseInt(id),
          };
          const res = await requestResolveOrder(payload);
          if (res.message === 'Updated') {
            IsAlert.fire({
              title: 'Success',
              text: 'Request resolve success.',
              icon: 'success',
              showCancelButton: false,
              focusConfirm: true,
              confirmButtonText: 'Confirm',
            });
          }
        } catch (error) {
          IsAlert.fire({
            title: 'Error',
            text: error?.response?.data?.message ?? 'Something when wrong.',
            icon: 'error',
            showCancelButton: false,
            focusConfirm: true,
            confirmButtonText: 'Confirm',
          });
        } finally {
          dispatch(changeLoading(false));
        }
      }
    });
  };

  const handleTrackingNumber = (str) => {
    const regex = /^[a-zA-Z0-9]+$/;
    setTrackingNumber(str);

    if (!str) {
      setTrackingNumberErrorMessage('Tracking number is required');
      return;
    }

    if (str?.length > 30) {
      setTrackingNumberErrorMessage('Maximum 30 Characters');
      return;
    }

    if (!regex.test(str)) {
      setTrackingNumberErrorMessage(
        'Tracking number must be alphanumeric without space'
      );
      return;
    }

    setTrackingNumberErrorMessage('');
  };

  useEffect(() => {
    let id = getIdFromSlug(slug);
    setId(id);
  }, [slug]);

  useEffect(() => {
    if (id) {
      getOrderDetailData();
    }
  }, [id]);

  useEffect(() => {
    // show hide box image upload
    if (samplePreview.length >= 1) {
      setShowUploadInputImage(false);
    } else {
      if (showUploadInputImage) {
        return;
      }
      setShowUploadInputImage(true);
    }
  }, [samplePreview]);

  useEffect(() => {
    // show hide box video upload
    if (sampleVideos.length >= 1) {
      setShowUploadInputVideo(false);
    } else {
      if (showUploadInputVideo) {
        return;
      }
      setShowUploadInputVideo(true);
    }
  }, [sampleVideos]);

  return (
    <div className="container-fluid mb-4 px-0 tab-navigasi">
      {isLoadingData ? (
        <LoadingComponent classList={['vh-100']} />
      ) : (
        <>
          <div className="mb-4 px-4 px-md-0">
            <a
              onClick={() => navigate('/orders')}
              className="fs-5 fw-bold d-flex flex-row align-items-center"
            >
              <img alt="back-button" src={ArrowLeft} className="icon-4 me-2" />
              <span>Order Detail</span>
            </a>
          </div>

          {data?.status?.toLowerCase() === 'order verified' && (
            <div className="mb-md-5 px-4 px-md-0 border-bottom border-md-0 border-2px mt-4 mt-md-3 pb-4">
              <div className="w-100 d-flex align-items-center justify-content-between rounded-3 b-shadow shadow-md-down-0 p-0 p-md-4">
                <div className="d-none d-md-block">
                  <div className="fw-bold">Order Confirmation</div>
                </div>
                <div className="d-flex flex-column-reverse flex-md-row w-md-100">
                  <button
                    onClick={handleRejectOrder}
                    className="btn btn-line w-md-100 fw-bold mt-3 mt-md-0"
                  >
                    Reject Order
                  </button>
                  <button
                    onClick={handleConfirmOrder}
                    className="btn btn-fill ms-md-3 w-md-100"
                  >
                    Accept Order
                  </button>
                </div>
              </div>
            </div>
          )}

          {data?.status?.toLowerCase() === 'confirmed' && (
            <>
              <div className="mb-md-5 px-4 px-md-0 border-bottom border-md-0 border-2px mt-4 mt-md-3 pb-4">
                <div className="w-100 d-flex align-items-center justify-content-between rounded-3 b-shadow shadow-md-down-0 p-0 p-md-4">
                  <div className="d-none d-md-block">
                    <div className="fw-bold">Order Confirmation</div>
                  </div>
                  <div className="d-flex flex-column-reverse flex-md-row w-md-100">
                    <button
                      className="btn btn-fill ms-md-3 w-md-100"
                      onClick={handleProcessOrder}
                    >
                      Processing
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="modalProcessing"
                tabIndex="-1"
                aria-labelledby="modalProcessingLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content p-3">
                    <div className="modal-header border-0">
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="w-100 empty-wrap h-unset d-flex flex-column">
                        <label className="form-label d-flex fw-semibold">
                          Sub District<div className="text-danger ps-1">*</div>
                        </label>
                        <select
                          className="form-control"
                          value={subDistrict}
                          onChange={(event) => {
                            setSubDistrict(event.target.value);
                          }}
                        >
                          <option value="">Choose Sub District</option>
                          {couriers.map((item, index) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.subdistrict_name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="modal-footer border-0 position-relative">
                      <div className="w-50 m-0 p-1">
                        <button
                          type="button"
                          className="btn w-100 btn-line fw-semibold"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="w-50 m-0 p-1">
                        <button
                          type="button"
                          className="btn w-100 m-0 m-sm-1 btn-fill fw-semibold"
                          data-bs-dismiss="modal"
                          onClick={handleProcessOrder}
                        >
                          Process
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {data?.status?.toLowerCase() === 'packing' && (
            // https://www.youtube.com/watch?v=3pQY--GR2sI
            // https://www.youtube.com/watch?v=0TTa5Ulmgds
            <>
              <div className="mb-md-5 px-4 px-md-0 border-bottom border-md-0 border-2px mt-4 mt-md-3 pb-4">
                <div className="w-100 d-flex align-items-center justify-content-between rounded-3 b-shadow shadow-md-down-0 p-0 p-md-4">
                  <div className="row d-flex flex-column-reverse flex-md-row w-md-100">
                    <div className="d-flex ">
                      <div className="w-50 px-2">
                        <span className="fw-bold d-block text-secondary mb-2">
                          Photo
                        </span>
                        <p className="text-secondary">
                          Attach a photo of product packaging
                        </p>

                        {showUploadInputImage ? (
                          <FileUpload
                            upload={handleUpload}
                            samplePreviews={samplePreview}
                            maxFile={1}
                            maxSizePerFile={40}
                          />
                        ) : null}

                        {samplePreview.map((item, index) => (
                          <AttachmentPreview
                            key={index}
                            attachment={item}
                            extension={item?.extension ?? ''}
                            handleClear={clearImageSelected.bind(this, index)}
                          />
                        ))}
                      </div>

                      <div className="w-50 px-2">
                        <span className="fw-bold d-block text-secondary mb-2">
                          Video
                        </span>
                        <p className="text-secondary">
                          Attach the product packaging video
                        </p>

                        {showUploadInputVideo ? (
                          <FileUpload
                            id={'video-upload'}
                            upload={handleUploadVideo}
                            samplePreviews={sampleVideos}
                            maxFile={1}
                            maxSizePerFile={40}
                            video
                          />
                        ) : null}

                        {sampleVideos.map((item, index) => (
                          <AttachmentPreview
                            key={index}
                            attachment={item}
                            attachmentType={'video'}
                            extension={item?.extension ?? ''}
                            handleClear={clearVideoSelected.bind(this, index)}
                          />
                        ))}
                      </div>
                    </div>

                    <div className="d-flex mt-4 mb-2">
                      <div className="w-50 px-2">
                        <span className="fw-bold d-block text-secondary mb-2">
                          Courier Name
                        </span>
                        <p className="text-secondary">
                          {courierData?.name ? courierData.name : '-'}
                        </p>
                      </div>
                      <div className="w-50 px-2">
                        <span className="fw-bold d-block text-secondary mb-2">
                          Courier Service
                        </span>
                        <p className="text-secondary">
                          {courierData?.service ? courierData.service : '-'}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex my-2">
                      <div className="w-100 px-2">
                        <span className="fw-bold d-block text-secondary mb-3">
                          Tracking Number *
                        </span>
                        <input
                          className="form-control fz-14 box-shadow-focus-0"
                          value={trackingNumber}
                          onChange={(event) => {
                            handleTrackingNumber(event.target.value);
                          }}
                        />
                        {trackingNumberErrorMessage && (
                          <div
                            style={{
                              color: '	#c70000',
                              fontSize: '13px',
                              marginTop: '0.3rem',
                            }}
                          >
                            {trackingNumberErrorMessage}
                          </div>
                        )}
                      </div>
                      <div className="w-100" />
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-between rounded-3 p-0 p-md-4">
                      <div className="d-none d-md-block">
                        <div className="fw-bold"></div>
                      </div>
                      <div className="d-flex flex-column-reverse flex-md-row w-md-100">
                        <button
                          className="btn btn-fill ms-md-3 w-md-100"
                          disabled={!trackingNumber}
                          onClick={handleShippingOrder}
                        >
                          Shipping
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="mb-md-5 px-4 px-md-0 border-bottom border-md-0 border-2px mt-4 mt-md-3 pb-2">
            <div className="w-100 rounded-3 flex-column flex-md-row-reverse b-shadow shadow-md-down-0 d-flex p-0 p-md-4">
              <div className="col-2 w-md-100 border-bottom border-md-0 pb-3 pb-md-0"></div>
              <div className="col-2 w-md-100 border-bottom border-md-0 pb-3 pb-md-0">
                {data?.status?.toLowerCase() !== 'order verified' &&
                  data?.status?.toLowerCase() !== 'new order' &&
                  data?.status?.toLowerCase() !== 'confirmed' &&
                  data?.status?.toLowerCase() !== 'packing' &&
                  data?.status?.toLowerCase() !== 'waiting for pickup' && (
                    <>
                      <p className="fz-14 fw-bold text-secondary mb-2 d-none d-md-block">
                        RECEIPT NUMBER
                      </p>
                      <span>{data?.tracking_number ?? '-'}</span>
                    </>
                  )}
              </div>
              <div className="col-2 w-md-100 border-bottom border-md-0 pb-3 pb-md-0">
                <p className="fz-14 fw-bold text-secondary mb-2 d-none d-md-block">
                  STATUS
                </p>
                <div className="badge-gray">{data?.status}</div>
              </div>
              <div className="col-6 w-md-100 pt-3 pt-md-0">
                <div className="row row-cols-1 row-cols-md-2 gx-3">
                  <div className="col">
                    <div className="w-100 d-flex align-items-start d-md-block">
                      <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                        ORDER NO
                      </p>
                      <p className="col-6 col-md-12 text-end text-md-start mb-2">
                        {data?.order_number}
                      </p>
                    </div>
                  </div>
                  <div className="col">
                    <div className="w-100 d-flex align-items-start d-md-block">
                      <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                        ORDER DATE
                      </p>
                      <p className="col-6 col-md-12 text-end text-md-start mb-2">
                        {validateString(
                          formatDateTimeSecond(new Date(data?.date))
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {validateString(data?.complain_date) !== '-' &&
            data?.status?.toLowerCase() !== 'refund' && (
              <div className="mb-md-5 px-4 px-md-0 border-bottom border-md-0 border-2px mt-4 mt-md-3 pb-2">
                <div className="w-100 rounded-3 flex-column flex-md-row-reverse b-shadow shadow-md-down-0 d-flex p-0 p-md-4">
                  {data?.status?.toLowerCase() === 'order complain' && (
                    <div className="col-3 w-md-100 border-bottom border-md-0 pb-3 pb-md-0">
                      <button
                        type="button"
                        className="btn m-0 m-sm-1 btn-fill fw-semibold"
                        onClick={handleRequestResolve}
                      >
                        Request Resolve
                      </button>
                    </div>
                  )}
                  <div
                    className={`col-${
                      data?.status?.toLowerCase() === 'order complain'
                        ? '3'
                        : '6'
                    } w-md-100 border-bottom border-md-0 pb-3 pb-md-0`}
                  >
                    <p className="fz-14 fw-bold text-secondary mb-2 d-none d-md-block">
                      COMPLAIN DURATION
                    </p>
                    <p className="col-6 col-md-12 text-end text-md-start mb-2">
                      {validateString(data?.complain_duration) === '-'
                        ? '-'
                        : validateString(data?.complain_duration)}
                    </p>
                  </div>
                  <div className="col-6 w-md-100 pt-3 pt-md-0">
                    <div className="row row-cols-1 row-cols-md-2 gx-3">
                      <div className="col">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            COMPLAIN DATE
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(data?.complain_date) === '-'
                              ? '-'
                              : validateString(data?.complain_date)}
                          </p>
                        </div>
                      </div>
                      <div className="col">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            RESOLVE DATE
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(data?.resolve_date) === '-'
                              ? '-'
                              : validateString(data?.resolve_date)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          <div className="w-100 d-flex align-items-lg-stretch flex-column flex-lg-row">
            <div className="col-12 col-lg-6 mb-md-5 px-4 pe-md-0 ps-md-0 pe-lg-3 border-bottom border-md-0 border-2px mt-4 mt-md-3 pb-2">
              <div className="w-100 rounded-3 b-shadow shadow-md-down-0 p-0 p-md-4 h-100">
                <div className="fw-bold mb-4">Shipping Detail</div>
                <div className="d-flex flex-column flex-md-row flex-lg-column">
                  <div className="col-lg-12 w-md-100">
                    <div className="row row-cols-1 row-cols-md-2 gx-3">
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            COURIER
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(data?.courier_name)}
                            {data?.courier_service_name
                              ? ' - ' + data?.courier_service_name
                              : ''}
                          </p>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            DISPATCH DATE
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {data?.dispatch_date
                              ? formatDate(new Date(data?.dispatch_date))
                              : '-'}
                          </p>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            NAME
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(data?.shipping_address?.recipient)}
                          </p>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            ADDRESS
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(data?.shipping_address?.address)}
                          </p>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            PROVINCE
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(
                              data?.shipping_address?.province_name
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            CITY
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(data?.shipping_address?.city_name)}
                          </p>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            DISTRICT
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(
                              data?.shipping_address?.district_name
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            SUB DISTRICT
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(
                              data?.shipping_address?.subdistrict_name
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            POST CODE
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(
                              data?.shipping_address?.postal_code
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="w-100 d-flex align-items-start d-md-block">
                          <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">
                            PHONE
                          </p>
                          <p className="col-6 col-md-12 text-end text-md-start mb-2">
                            {validateString(data?.shipping_address?.phone)}
                          </p>
                        </div>
                      </div>
                      {/* <div className="col mb-3">
                                            <div className="w-100 d-flex align-items-start d-md-block">
                                                <p className="col-6 col-md-12 fz-14 fw-bold text-secondary mb-2">ORDER NOTE</p>
                                                <p className="col-6 col-md-12 text-end text-md-start mb-2">{validateString(data?.order_notes)}</p>
                                            </div>
                                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 mb-md-5 px-4 pe-md-0 ps-md-0 border-bottom border-md-0 border-2px mt-4 mt-md-3 pb-2">
              <div className="w-100 rounded-3 b-shadow shadow-md-down-0 p-0 p-md-4 h-100">
                <div className="fw-bold mb-4">Payment</div>
                <div className="d-flex flex-column flex-md-row flex-lg-column">
                  <div className="col-lg-12 w-md-100">
                    <div className="row row-cols-1 gx-3">
                      <div className="col">
                        <div className="w-100 d-flex align-items-start">
                          <p className="col-6 fz-14 fw-bold text-secondary mb-2">
                            TOTAL AMOUNT
                          </p>
                          <p className="col-6 text-end mb-2">
                            {validateString(
                              formatMoney(data?.sub_total, 'Rp.', 0, ',', '.')
                            )}
                          </p>
                        </div>
                      </div>

                      <div className="col">
                        <div className="w-100 d-flex align-items-start">
                          <p className="col-6 fz-14 fw-bold text-secondary mb-2">
                            VOUCHER
                          </p>
                          <p className="col-6 text-end mb-2">
                            {validateString(
                              formatMoney(data?.voucher, 'Rp.', 0, ',', '.')
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col">
                        <div className="w-100 d-flex align-items-start">
                          <p className="col-6 fz-14 fw-bold text-secondary mb-2">
                            SHIPPING
                          </p>
                          <p className="col-6 text-end mb-2">
                            {validateString(
                              formatMoney(data?.shipping, 'Rp.', 0, ',', '.')
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col">
                        <div className="w-100 d-flex align-items-start">
                          <p className="col-6 fz-14 fw-bold text-secondary mb-2">
                            SERVICE FEE
                          </p>
                          <p className="col-6 text-end mb-2">
                            {validateString(
                              formatMoney(data?.service_fee, 'Rp.', 0, ',', '.')
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col">
                        <div className="w-100 d-flex align-items-start">
                          <p className="col-6 fz-14 fw-bold text-secondary mb-2">
                            TOTAL AMOUNT AFTER
                          </p>
                          <p className="col-6 text-end mb-2">
                            {validateString(
                              formatMoney(data?.total, 'Rp.', 0, ',', '.')
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-100 rounded-3 b-shadow shadow-md-down-0 p-0 p-md-4 h-100">
            <div className="w-100 px-4 mt-4 mt-md-3 px-md-0">
              <table
                id="table_id2"
                className="table table-striped"
                style={{ width: '100%' }}
              >
                <thead>
                  <tr>
                    <th>SKU</th>
                    <th>Name</th>
                    <th>Variant</th>
                    <th>Qty</th>
                    <th className="w-15-persen">Price</th>
                    <th>Discount</th>
                    <th>Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.items?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{validateString(item?.sku)}</td>
                        <td>{validateString(item?.name)}</td>
                        <td>
                          {validateString(item?.size + ' - ' + item?.color)}
                        </td>
                        <td>{validateString(item?.quantity)}</td>
                        <td>
                          {validateString(
                            formatMoney(item?.price, 'Rp.', 0, ',', '.')
                          )}
                        </td>
                        <td>
                          {validateString(
                            formatMoney(
                              item?.discount_amount,
                              'Rp.',
                              0,
                              ',',
                              '.'
                            )
                          )}
                        </td>
                        <td>
                          {validateString(
                            formatMoney(item?.total, 'Rp.', 0, ',', '.')
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderDetail;
